// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1483":"6b51223a","1513":"6b51223a","4873":"6b51223a","8595":"6b51223a","9927":"6b51223a"}[chunkId] + ".chunk.css";
};